// Path: src/components/aols/aeo/OLSupdates/OLS2900/OLS2900.tsx
// Updated to import and display the new OLS2965 Live Help Desk announcement.

import React, { useEffect } from "react";
import { Layout, Typography, Breadcrumb, List } from "antd";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import { HomeOutlined } from "@ant-design/icons";
import { useFirebase } from "../../../../dev/Firebase/Firebase";
import OLS2903 from "./OLS2903";
import OLS2904 from "./OLS2904";
import OLS2905 from "./OLS2905";
import OLS2908 from "./OLS2908";
import OLS2909 from "./OLS2909";
import OLS2910 from "./OLS2910";
import OLS2911 from "./OLS2911";
import OLS2912 from "./OLS2912";
import OLS2913 from "./OLS2913";
import OLS2914 from "./OLS2914";
import OLS2915 from "./OLS2915";
import OLS2916 from "./OLS2916";
import OLS2917 from "./OLS2917";
import OLS2918 from "./OLS2918";
import OLS2919 from "./OLS2919";
import OLS2920 from "./OLS2920";
import OLS2921 from "./OLS2921";
import OLS2922 from "./OLS2922";
import OLSLM2922 from "./OLSLM2922";
import OLSLM2923 from "./OLSLM2923";
import OLSLM2924 from "./OLSLM2924";
import OLS2945 from "./OLS2945";
import OLS2953 from "./OLS2953";
import OLS2965 from "./OLS2965";
import OLS2967 from "./OLS2967"; // Added import for OLS2967

const { Title } = Typography;

export interface Update {
  id: string;
  text: string;
  thumbnail?: string;
}

export const updates2900: Update[] = [
  // Added OLS2967 to appear at the top of the list
  {
    id: "2967",
    text: "OLS Health Improvements Package: Premium Wellness for All",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2Fols-health-package-announcement.png?alt=media&token=d2b4c6e8-1f9e-4b8a-9d8e-a0f3b2c4d5e6",
  },
   {
    id: "2966",
    text: "Discover Your Path: OLS Packages & Journeys Now Available",
    thumbnail: "https://images.placeholders.dev/?width=100&height=100&text=OLS%20Packages&bgColor=%231a1a1a&textColor=%23ffaa00",
  },
  {
    id: "2965",
    text: "OLS Chat support  Live Instant Assistance for Your Luminous Journey",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/img-public%2F2966.OLSchat.png?alt=media&token=9faaca8a-e3d0-42c2-8ef0-e95135d35079",
  },
  {
    id: "2924.olslm",
    text: "OLSLM: 2924.126.3413",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F2193.1.126.png?alt=media&token=31b29be4-44d7-46f8-bcb4-42a538704376",
  },
  {
    id: "2923.olslm",
    text: "OLSLM: 2923.125.3412",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F731.2LH125.png?alt=media&token=922c0422-4809-4b4f-a5e6-7ab37ef05491",
  },
  {
    id: "2953",
    text: "OLS Referral Program: 5% Promotion Tool to Receive Extra Commission",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/img-public%2F2953.referral.png?alt=media&token=447b948f-7b14-443e-83cb-db416a5bc715",
  },
  {
    id: "2945",
    text: "Limited-Time Offer: Add OLS Calendar Widget & New Light Time Clock to Your Website!",
    thumbnail: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/img-public%2F2845.OLSwebdev.png?alt=media&token=b518e3fa-caad-49eb-bf21-24a67f892024",
  },
  {
    id: "2922.olslm",
    text: "OLSLM: 2922.124.3411",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F730.13.124.png?alt=media&token=8f683195-d9ec-491a-9003-a4b5d7d69df5",
  },
  {
    id: "2921",
    text: "OLSLM: 2921.123.3410",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F729.2.123.png?alt=media&token=2f447a9f-51f8-4ebf-8c83-3b6dea46ab3d",
  },
  {
    id: "2922",
    text: "Celebrating 8 Years of OLS: 20% Discount for New Students",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/img-public%2F2920.OLSLM%20logo.png?alt=media&token=34b012f0-92fa-4c1b-beee-bdaacfc7eddd",
  },
  {
    id: "2920",
    text: "OLSLM: 2920.122.3409",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F728.1.122.png?alt=media&token=30c74a8e-a8f1-47a8-a1e1-908f8b634f3b",
  },
  {
    id: "2919",
    text: "OLSLM: 2919.121.3409",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F727.2.121.png?alt=media&token=e0e3e000-c5ef-4b8a-bcf1-60210e1163a7",
  },
  {
    id: "2918",
    text: "OLSLM: 2918.120.3409",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F726.3.120.png?alt=media&token=37d01fbe-1e29-48cc-a66d-aed497d88d31",
  },
  {
    id: "2917",
    text: "OLSLM: 2917.119.3409",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F725.2.119.png?alt=media&token=c9a9ce10-46fc-4e15-b784-d1a61dda254e",
  },
  {
    id: "2916",
    text: "OLSLM: 2916.118.3408",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F724.11.118.png?alt=media&token=cefca50f-04a6-4b7c-8d97-6230f402c7c2",
  },
  {
    id: "2915",
    text: "OLSLM: 2915.117.3407",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F723.11.117.png?alt=media&token=527b403d-02f1-43cd-99cc-b6fda477cb00",
  },
  {
    id: "2914",
    text: "OLSLM: 2914.116.3406",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F722.12.116.png?alt=media&token=a1ff686b-1670-45ba-aa5c-7173c85aab94",
  },
  {
    id: "2913",
    text: "OLSLM: 2913.115.3405",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F1452.1.115.png?alt=media&token=0ccff00d-9cfd-4b4a-b065-a656f45dff87",
  },
  {
    id: "2912",
    text: "OLSLM: 2912.114.3404",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F720.12.114.png?alt=media&token=cdf1f976-8dfc-4ef3-8c86-5417b31d7eb7",
  },
  {
    id: "2911",
    text: "OLSLM: 2911.113.3403",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F719.1.113.27.png?alt=media&token=f15ec58c-b9ff-4b14-8ecc-b869115b474b",
  },
  {
    id: "2910",
    text: "OLSLM: 2910.112.3402",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/imgOLSLM%2F718.12.112.png?alt=media&token=f7beceda-8e9d-410e-add0-195fe2e682a5",
  },
  {
    id: "2909",
    text: "OLSLM: 2909.111.3401",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2F717.12.111.png?alt=media&token=1cca7002-4221-401e-b4a5-9bf97a4a5ada",
  },
  {
    id: "2908",
    text: "OLSLM: 2908.110.3400",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2F716.10.110.png?alt=media&token=61f57de4-3fe9-460d-80ff-5cc5119693bf",
  },
  {
    id: "2905",
    text: "OLSLM: 2905.107.3399",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2F713.12.107.png?alt=media&token=f25ca805-e668-4240-b9f3-a5455c186b4b",
  },
  {
    id: "2904",
    text: "OLSLM: 2904.106.3398",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2F1443.1.106.png?alt=media&token=29e36961-1848-4366-a869-03880f667c81",
  },
  {
    id: "2903",
    text: "OLSLM: 2903.105.3397",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2F711.1.105.png?alt=media&token=1b53d210-f977-4fb3-9b76-85e3a862068e",
  },
];

const FeedContainer = styled.div`
  background: #000000;
  min-height: 100vh;
  padding: 40px 20px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FeedContent = styled.div`
  max-width: 800px;
  width: 100%;
  background: #1a1a1a;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
`;

const FeedTitle = styled(Title)`
  color: #ffcc00 !important;
  margin-bottom: 20px;
  text-align: center;
`;

const UpdateLink = styled(Link)`
  color: #ffaa00 !important;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;

  &:hover {
    color: #ffcc00 !important;
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid #40c4ff;
    outline-offset: 2px;
  }
`;

const BreadcrumbWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 20px;
  z-index: 1001;

  .ant-breadcrumb a {
    color: #ffcc00;
    transition: color 0.3s ease;
  }

  .ant-breadcrumb a:hover {
    color: #ffaa00;
  }

  @media (max-width: 768px) {
    left: 10px;
    top: 5px;
    .ant-breadcrumb {
      font-size: 12px;
    }
  }
`;

const UpdateThumbnail = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  margin-right: 16px;
  border: 1px solid #ffaa00;
`;

const ListItem = styled(List.Item)`
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #333;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #2a2a2a;
  }
`;

const OLS2900: React.FC = () => {
  const { logEvent } = useFirebase();

  useEffect(() => {
    logEvent("page_view", { page_path: "/olsupdates/ols2900" });
  }, [logEvent]);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "OLS2900 Updates - onelightsystem OLS",
    description: "Latest updates for OLS2900 from onelightsystem OLS, including OLSLM 2924, OLSLM 2923, widget announcements, progress updates, and detailed posts.",
    url: "https://www.olsme.com/olsupdates/ols2900",
    publisher: {
      "@type": "Organization",
      name: "onelightsystem OLS",
      url: "https://www.olsme.com",
      logo: "https://www.olsme.com/logo.jpg",
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.olsme.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "OLS Updates",
          item: "https://www.olsme.com/olsupdates",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "OLS2900",
          item: "https://www.olsme.com/olsupdates/ols2900",
        },
      ],
    },
  };

  return (
    <Layout>
      <Helmet>
        <title>OLS2900 Updates - onelightsystem OLS</title>
        <meta
          name="description"
          content="Latest updates for OLS2900 from onelightsystem OLS, including OLSLM 2924, OLSLM 2923, widget announcements like the OLS Calendar Widget and Light Time Clock, progress updates, and detailed posts for OLS students and members."
        />
        <meta
          name="keywords"
          content="OLS2900 updates, onelightsystem OLS, Sun Light Meditation, OLS updates, Light Civilization, meditation education, OLS Calendar Widget, Light Time Clock Widget, correct calendar, OLSLM 2924, OLSLM 2923"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="OneLightSystem OLS" />
        <link rel="canonical" href="https://www.olsme.com/olsupdates/ols2900" />
        <meta property="og:title" content="OLS2900 Updates - onelightsystem OLS" />
        <meta
          property="og:description"
          content="Latest updates for OLS2900 from onelightsystem OLS, including OLSLM 2924, OLSLM 2923, widget announcements like the OLS Calendar Widget and Light Time Clock, progress updates, and detailed posts for OLS students and members."
        />
        <meta property="og:url" content="https://www.olsme.com/olsupdates/ols2900" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.olsme.com/logo.jpg" />
        <meta property="og:image:alt" content="onelightsystem OLS Logo for OLS2900 Updates" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="onelightsystem OLS" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@onelightsystem" />
        <meta name="twitter:title" content="OLS2900 Updates - onelightsystem OLS" />
        <meta
          property="twitter:description"
          content="Latest updates for OLS2900 from onelightsystem OLS, including OLSLM 2924, OLSLM 2923, widget announcements like the OLS Calendar Widget and Light Time Clock, progress updates, and detailed posts for OLS students and members."
        />
        <meta name="twitter:image" content="https://www.olsme.com/logo.jpg" />
        <meta name="twitter:image:alt" content="onelightsystem OLS Logo for OLS2900 Updates" />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>

      <BreadcrumbWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">
              <HomeOutlined /> Home
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/olsupdates">OLS Updates</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>OLS2900</Breadcrumb.Item>
        </Breadcrumb>
      </BreadcrumbWrapper>

      <FeedContainer>
        <FeedContent>
          <FeedTitle level={1}>OLS2900 Updates</FeedTitle>
          <List
            dataSource={updates2900}
            renderItem={(update) => (
              <ListItem>
                {update.thumbnail && (
                  <UpdateThumbnail
                    src={update.thumbnail}
                    alt={`Thumbnail for ${update.text}`}
                  />
                )}
                <UpdateLink to={`/olsupdates/ols2900/${update.id}`} aria-label={`View update ${update.text}`}>
                  {update.text}
                </UpdateLink>
              </ListItem>
            )}
          />
        </FeedContent>
      </FeedContainer>
    </Layout>
  );
};

export default OLS2900;